import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface LocationMismatchConfirmationData {
    bottleName: string;
    bottleLocation: string;
    logLocation: string;
}

export interface LocationMismatchConfirmationResult {
    changeLocation: boolean;
}

@Component({
    selector: 'location-mismatch-confirmation-dialog',
    templateUrl: './location-mismatch-confirmation.dialog.html',
    styleUrls: ['./location-mismatch-confirmation.dialog.scss']
})
export class LocationMismatchConfirmationDialog {
    constructor(
        public dialogRef: MatDialogRef<LocationMismatchConfirmationDialog>,
        @Inject(MAT_DIALOG_DATA) public data: LocationMismatchConfirmationData
    ) {}

    onKeepBottleLocation(): void {
        this.dialogRef.close({ changeLocation: false } as LocationMismatchConfirmationResult);
    }

    onChangeBottleLocation(): void {
        this.dialogRef.close({ changeLocation: true } as LocationMismatchConfirmationResult);
    }
}